import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CatalogueGrid = _resolveComponent("CatalogueGrid")!
  const _component_FilterDialog = _resolveComponent("FilterDialog")!
  const _component_PackagesSelectionWorkflow = _resolveComponent("PackagesSelectionWorkflow")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_CatalogueGrid, {
      summaryConfig: _ctx.summaryConfig,
      controller: 'PlanPackage',
      columns: _ctx.columns,
      filterRowVisible: true,
      groupPanelVisible: true,
      headerFilterVisible: true,
      filterPanelVisible: false,
      showPageSizeSelector: !_ctx.selectMode,
      pageSize: 10,
      pageSizes: _ctx.pageSizes,
      editingConfig: _ctx.editingConfig,
      selectionConfig: _ctx.selectionConfig,
      designConfig: _ctx.designConfig,
      getSelectedData: _ctx.getSelectedData,
      changeSelectedData: _ctx.changeSelectedData,
      parentModel: _ctx.parentModel,
      importConfig: _ctx.importConfig,
      exportConfig: _ctx.exportConfig,
      selectMode: _ctx.selectMode,
      toolbarItems: _ctx.toolbarItems,
      additionalFilters: _ctx.additionalFilters,
      onOnToolbarPreparing: _ctx.onToolbarPreparing,
      onRowInserted: _ctx.onRowInserted,
      onRowRemoved: _ctx.onRowsRemoved,
      onRowUpdated: _ctx.onRowUpdated,
      onRemoveAllRows: _ctx.onRowsRemoved,
      onOnImportClose: _ctx.onImportClose,
      onOnDataFillApply: _ctx.onDataFillApply,
      onRowValidating: _ctx.onRowValidating,
      onRememberScrollSettings: _ctx.rememberScrollSettings,
      onUpdateParentModelCallback: _ctx.onUpdateParentModelCallback,
      ref: "grid"
    }, null, 8, ["summaryConfig", "columns", "showPageSizeSelector", "pageSizes", "editingConfig", "selectionConfig", "designConfig", "getSelectedData", "changeSelectedData", "parentModel", "importConfig", "exportConfig", "selectMode", "toolbarItems", "additionalFilters", "onOnToolbarPreparing", "onRowInserted", "onRowRemoved", "onRowUpdated", "onRemoveAllRows", "onOnImportClose", "onOnDataFillApply", "onRowValidating", "onRememberScrollSettings", "onUpdateParentModelCallback"]),
    _createVNode(_component_FilterDialog, {
      ref: "filterDialog",
      planId: _ctx.parentModel.id,
      isFilter: _ctx.isFilter,
      onApplyFilter: _ctx.applyFilter,
      onResetFilter: _ctx.resetFilter
    }, null, 8, ["planId", "isFilter", "onApplyFilter", "onResetFilter"]),
    (!_ctx.selectMode)
      ? (_openBlock(), _createBlock(_component_PackagesSelectionWorkflow, {
          key: 0,
          onProgressClose: _ctx.onSelectionClose,
          ref: "packagesSelectionWorkflow"
        }, null, 8, ["onProgressClose"]))
      : _createCommentVNode("", true)
  ]))
}